import * as React from 'react';
import { DatagridBody } from 'react-admin';
import CustomDatagridRow from './customDataGridRow'
  
const CustomDatagridBody = props => <DatagridBody {...props} row={<CustomDatagridRow />} />;

export default CustomDatagridBody;
  